<script setup lang="ts">
import PartnerRakutenClosing from './PartnerRakutenClosing/PartnerRakutenClosing.vue';
import PartnerRakutenFooter from './PartnerRakutenFooter/PartnerRakutenFooter.vue';
import PartnerRakutenHeader from './PartnerRakutenHeader/PartnerRakutenHeader.vue';
import PartnerRakutenHero from './PartnerRakutenHero/PartnerRakutenHero.vue';
import PartnerRakutenIntroduction from './PartnerRakutenIntroduction/PartnerRakutenIntroduction.vue';
// import PartnerRakutenReviews from './PartnerRakutenReviews/PartnerRakutenReviews.vue';
// import PartnerRakutenTopics from './PartnerRakutenTopics/PartnerRakutenTopics.vue';
import PartnerRakutenReviewsCollection from './PartnerRakutenReviewsCollection/PartnerRakutenReviewsCollection.vue';
import PartnerRakutenService from './PartnerRakutenService/PartnerRakutenService.vue';
import PartnerRakutenVoice from './PartnerRakutenVoice/PartnerRakutenVoice.vue';
import PartnerRakutenCase from '~/components/organisms/_lp/PartnerRakutenCase/PartnerRakutenCase.vue';

const items = [
  '家族は妻（37歳、パート）、10歳の子供1人',
  '世帯年収900万（夫の年収800万／妻の年収100万）',
  '貯蓄（定期預金1500万／普通預金80万）',
  '住居費14万 持ち家・マンション',
  '月額の保険料20,000円',
];
</script>

<template>
  <main class="layout">
    <PartnerRakutenHeader class="layout__header" />
    <PartnerRakutenHero class="layout__hero" />
    <!-- PO判断で一旦コメント・トピックセクションは無しでリリースすると決定したのでコメントアウト -->
    <!-- <PartnerRakutenReviews class="layout__reviews" /> -->
    <!-- <PartnerRakutenTopics class="layout__topics" /> -->
    <PartnerRakutenService id="service" class="layout__service" />
    <PartnerRakutenReviewsCollection />
    <PartnerRakutenIntroduction
      id="introduction"
      class="layout__introduction"
    />
    <PartnerRakutenCase
      id="case"
      class="layout__case"
      heading="300万円を運用して老後資金を賄うことは可能か？"
      info="（たかしさん 41歳男性／会社員／東京都）"
      description="銀行に預けているお金のうち300万円ほどを運用して老後に備えたいです。運用期間は15〜20年で、低リスクなものが良いので、個人向け国債の購入を検討していますが、老後資金の準備としてどうでしょうか。老後資金をどのくらい準備すればいいのかも知りたいです。"
      :items="items"
    >
      <template #answer>
        <p>
          41歳にして老後資金のことを考えているのは素晴らしいことですね。私はたかしさんと同世代なのですが、周囲は子供の教育資金をどうしよう…と悩んでおり、老後まで考えられてない方々が大半です。<br /><br />一般的に「ゆとりある老後生活費」は夫婦で36万円程度と言われています。その生活を退職（65歳）後25年間続けると想定しますと、1億800万円が必要となります。<br />現在の世帯年収であれば、たかしさんの場合、年金は23万円以上は見込めるため、25年間でおよそ6,900万円は年金により賄えます。すると現在の貯蓄と合わせてご退職されるまでに4,000万円をここから25年間で準備する必要があります。<br /><br />個人向け国債は確かに低リスクな金融商品ですが、金利固定で年率0.05%です。こちらを300万円で購入した場合、1,500円×20年=3万円となり、必要と思われる4,000万円が賄えないことが考えられます。<br /><br />一例ですが、世界経済の成長に連動するインデックスファンドなどの分散された商品への投資を検討されてみてはいかがでしょうか。商品の選択は難しいですよね。ですが、平均年利は4〜7%ですから初期投資300万円に加えて、毎月数万円積み立てることで20年後には4,000万ほどになることが予想されます。<br /><br />より具体的な商品だったり、老後までのご提案をさせていただくためにも、一度老後までの収入および支出のシミュレーションをしてみませんか。それをもとに将来の資金計画を立てることができますので、ご検討ください！
        </p>
      </template>
    </PartnerRakutenCase>
    <PartnerRakutenVoice id="voice" class="layout__voice" />
    <PartnerRakutenClosing class="layout__closing" />
    <PartnerRakutenFooter class="layout__footer" />
  </main>
</template>

<style lang="scss" scoped>
.layout {
  position: relative;
}
</style>
